module.exports = __webpack_public_path__ + "static/media/strongher5_preview.927c7ca4.jpg";